import { render, staticRenderFns } from "./StarJoinWrap.vue?vue&type=template&id=b26928e2"
import script from "./StarJoinWrap.vue?vue&type=script&lang=js"
export * from "./StarJoinWrap.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports